import React from "react";
import foo_logo from "../assets/foo_mascot_chef_hat@2x.svg"; // Import the logo

interface BlockedScreenProps {
  clientId: string;
}

export const BLOCKED_CLIENT_IDS = ["54"];
const BlockedScreen: React.FC<BlockedScreenProps> = ({ clientId }) => {
  if (!BLOCKED_CLIENT_IDS.includes(clientId)) {
    return null; // Not a blocked client, render nothing
  }

  const blueColor = "#3f72af"; // The partner-color blue

  return (
    <div
      style={{
        backgroundColor: "#f78f03", // Consistent with PaymentWarningBar for main background
        color: "#000000",
        textAlign: "center",
        width: "100vw",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between", // Distribute space
        alignItems: "center",
        zIndex: 10000,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      {/* Top Blue Line */}
      <div
        style={{
          width: "100%",
          height: "50px",
          backgroundColor: blueColor,
        }}
      ></div>

      {/* Main Content */}
      <div
        style={{
          flexGrow: 1, // Allows this div to take up available space
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px", // Adjusted padding for main content
        }}
      >
        <img
          src={foo_logo}
          alt="Company Logo"
          style={{ maxWidth: "150px", marginBottom: "30px" }}
        />
        <h1>⛔ Acceso Bloqueado ⛔</h1>
        <p>
          Estimado usuario, su acceso ha sido temporalmente suspendido debido a
          problemas con su suscripción.
        </p>
        <p>
          Por favor, póngase en contacto con nuestro equipo de soporte para
          regularizar su situación y restablecer el servicio.
        </p>
        <p>¡Gracias por su comprensión!</p>
      </div>

      {/* Bottom Blue Line */}
      <div
        style={{
          width: "100%",
          height: "50px",
          backgroundColor: blueColor,
        }}
      ></div>
    </div>
  );
};

export default BlockedScreen;
